import { render, staticRenderFns } from "./HandleRecord.vue?vue&type=template&id=0f9dc714&"
import script from "./HandleRecord.vue?vue&type=script&lang=js&"
export * from "./HandleRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports